import React from 'react';
import Dropdown from 'react-bootstrap/Dropdown';
import { useTheme } from '../theme/ThemeContext';

const ICON = {
  light: 'fa-sun',
  dark: 'fa-moon',
  system: 'fa-circle-half-stroke',
};

const LABEL = {
  light: 'Light',
  dark: 'Dark',
  system: 'System',
};

export default function ThemeToggle() {
  const { theme, setTheme } = useTheme();
  const icon = ICON[theme] ?? ICON.system;

  return (
    <Dropdown align="end" className="m-2">
      <Dropdown.Toggle
        variant="outline-secondary"
        id="themeToggleButton"
        aria-label={`Theme: ${LABEL[theme]}`}
        title={`Theme: ${LABEL[theme]}`}
      >
        <i className={`fa-solid ${icon}`} aria-hidden="true"></i>
      </Dropdown.Toggle>
      <Dropdown.Menu>
        <Dropdown.Header>Theme</Dropdown.Header>
        {(['light', 'dark', 'system']).map((value) => (
          <Dropdown.Item
            key={value}
            as="button"
            active={theme === value}
            onClick={() => setTheme(value)}
          >
            <i className={`fa-solid ${ICON[value]} me-2`} aria-hidden="true"></i>
            {LABEL[value]}
          </Dropdown.Item>
        ))}
      </Dropdown.Menu>
    </Dropdown>
  );
}
